import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

interface ErrorModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  message?: string;
  isDarkMode?: boolean;
  confirmText?: string;
  onConfirm?: () => void;
  onRetry?: () => void;
  retryText?: string;
  isRetrying?: boolean;
}

export function ErrorModal({
  open,
  onOpenChange,
  title = "Error",
  message = "Something went wrong. Please try again.",
  isDarkMode = false,
  confirmText = "OK",
  onConfirm,
  onRetry,
  retryText = "Retry",
  isRetrying = false,
}: ErrorModalProps) {
  const handleClose = () => {
    if (onConfirm) {
      onConfirm();
    }
    onOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!isRetrying) onOpenChange(next);
      }}
    >
      <DialogContent
        className={`sm:max-w-[400px] transition-colors duration-300 ${
          isDarkMode
            ? "bg-gray-900 border-gray-700"
            : "bg-white border-gray-200"
        }`}
      >
        <DialogHeader>
          <DialogTitle
            className={`text-lg font-semibold transition-colors duration-300 ${
              isDarkMode ? "text-white" : "text-gray-900"
            }`}
          >
            {title}
          </DialogTitle>
        </DialogHeader>

        <p
          className={`mt-2 text-sm transition-colors duration-300 ${
            isDarkMode ? "text-red-400" : "text-red-600"
          }`}
        >
          {message}
        </p>

        <div className="flex justify-end gap-2 pt-6">
          <Button
            onClick={handleClose}
            disabled={isRetrying}
            variant={onRetry ? "outline" : "default"}
            className={
              onRetry ? "px-6" : "px-6 text-white bg-black hover:bg-gray-800"
            }
          >
            {confirmText}
          </Button>
          {onRetry && (
            <Button
              onClick={onRetry}
              disabled={isRetrying}
              className="px-6 text-white bg-black hover:bg-gray-800"
            >
              {isRetrying ? "Retrying..." : retryText}
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
